import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  card: {
    position: 'relative',
  },
  cardSelectable: {
    '&:hover': {
      cursor: 'pointer',
      opacity: '80%',
    },
  },
  cardEditable: {
    '& .rccs__issuer': {
      top: '22%',
    },
    '& .rccs__chip': {
      top: '22%',
    },
    '& .rccs__number': {
      top: '49%',
    },
  },
  editIcon: {
    position: 'absolute',
    top: 10,
    right: 27,
    zIndex: 1,
  },
  menuPaper: {
    border: '1px solid #d3d4d5',
    marginBottom: 61,
  },
  menuItemIcon: {
    minWidth: 40,
  },
  removeCardText: {
    color: '#dc3f53',
  },
  icon: {
    fontSize: 40,
    position: 'absolute',
    top: '1%',
    right: -10,
    zIndex: 1,
  },
}));
